import { IColetaNoCd } from '../../../../../store/ducks/coletaNoCd/types';
import mask from '../../../../../utils/mask';

interface ExportBtnProps {
  'Pedido ': number;
  'Nota fiscal': number;
  'Parceiro ': string;
  'Emissao do pedido': string | Date;
  'Transportadora ': string;
  'Cidade destino': string;
  'Peso ': string;
  'Valor ': string;
}

export const exportDataColetaNoCd = (data: IColetaNoCd[]): ExportBtnProps[] =>
  data?.map(
    (item): ExportBtnProps => {
      return {
        'Pedido ': item.nuNotaPedido,
        'Nota fiscal': item.numNF,
        'Parceiro ': item.cliente,
        'Emissao do pedido': mask('date', item.dtEmissao),
        'Transportadora ': item.transportadora,
        'Cidade destino': item.cidadeUf,
        'Peso ': mask('peso', item.pesoBruto),
        'Valor ': mask('currency', item.valor),
      };
    }
  );
